<template>
  <div class="limiter dark-page">
    <v-app-bar app fixed flat height="60" color="#121212" dark>
      <v-spacer></v-spacer>
      <v-img src="../../assets/logoInteliteAICheff.png" width="100%" max-width="250px" class="ma-2"></v-img>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-app-bar app fixed flat height="100" style="top: 60px" color="#1a1a1a" dark>
      <v-spacer></v-spacer>
      <v-slide-group
        class="pa-4"
        mandatory
        active-class="teal"
        show-arrows
        :key="updateKey"
      >
        <v-slide-item v-for="categoria in categorias" :key="categoria.id" v-slot="{ toggle }">
          <v-img
            width="150px"
            height="80px"
            :src="categoria.urlImagem"
            @click="() => { scrollToCategoryId(categoria.descricao.normalize('NFD')); toggle(); categoriaAtivaId = categoria.descricao; }"
            v-if="filterProductsbyCategoria(categoria.id).length > 0"
            class="white--text align-end mx-2 category-thumb"
          >
            <div class="category-thumb__overlay">
              <p class="category-thumb__label" width="100%">
                <v-avatar
                  v-if="getTotalQuantidade(categoria.id) > 0"
                  left
                  :class="getTotalQuantidade(categoria.id) > 0? 'orange darken-3' : 'grey darken-1'"
                  size="15"
                  style="margin-bottom: 2px; margin-right: 2px"
                >
                  <span class="white--text">{{getTotalQuantidade(categoria.id)}}</span>
                </v-avatar>
                <b>{{ categoria.descricao }}</b>
              </p>
            </div>
          </v-img>
        </v-slide-item>
      </v-slide-group>
      <v-spacer></v-spacer>
    </v-app-bar>
    <div class="container-login">
      <v-row align="center" justify="center" dense>
        <v-col v-for="item in categorias" :key="item.id" cols="12">
          <v-toolbar
            v-if="filterProductsbyCategoria(item.id).length > 0"
            flat dense color="#1e1e1e" dark
            class="category-header"
            :id="item.descricao.normalize('NFD')"
          >
            <v-toolbar-title class="category-header__title">{{item.descricao}}</v-toolbar-title>
          </v-toolbar>
          <v-card v-for="produto in filterProductsbyCategoria(item.id)" :key="produto.id" outlined elevation="2" class="product-card" color="#1e1e1e" dark>
          <KeepAlive>    
            <v-row style="margin: 0">
              <v-col xs="2" sm="2" md="2" lg="2" xl="2" style="text-align: center;" align-self="center">
                <v-avatar size="90px" tile class="ma-0" @click="exibeImagem(produto.urlImagem)">
                  <v-img style="border-radius: 15px;" :src="produto.urlImagem"></v-img>
                </v-avatar>
              </v-col>
              <v-col xs="7" sm="7" md="7" lg="7" xl="7" align-self="center">
                <v-card-title class="text-h6 product-title">{{ produto.descricao }}</v-card-title>
                <v-card-subtitle class="product-subtitle">{{ produto.detalhes }}</v-card-subtitle>
                <v-card-actions>
                  <v-btn class="ml-2 mt-0 action-btn" outlined rounded small color="teal lighten-1" @click="openDialogAdc(produto)">Adicionais</v-btn>
                  <v-btn class="ml-2 mt-0 action-btn" outlined rounded small color="orange darken-2" @click="openDialogObs(produto)">Obs.</v-btn>
                </v-card-actions>
              </v-col>
              <v-col  xs="3" sm="3" md="3" lg="3" xl="3" align-self="center" style="text-align: center;">
                <!-- <v-card-subtitle style="padding-top: 1px;padding-bottom: 1px;">A partir de</v-card-subtitle> -->
                <h2 class="product-price">R$ {{produto.preco}}</h2>
                <v-row justify="center">
                  <v-btn class="mx-1" @click="removeProduto(produto)" fab dark small outlined color="#00BFA5" :disabled="produto.quantidade == 0">
                    <v-icon dark>remove</v-icon>
                  </v-btn>
                  <v-subheader style="font-weight: bold; font-size: 22px;">{{produto.quantidade == undefined ? 0 : produto.quantidade}}</v-subheader>
                  <v-btn class="mx-1" @click="addProduto(produto)" fab dark small outlined color="#00BFA5">
                    <v-icon dark>add</v-icon>
                  </v-btn>
                </v-row>
              </v-col>
            </v-row>
        </KeepAlive>         
        </v-card> 
      </v-col>
    </v-row>
    </div>
    <v-footer dark padless class="footer" app color="#121212">
      <v-btn
        @click="scrollToClass()"
        color="#EF6C00"
        dark
        absolute
        small
        top
        right
        fab
      >
        <v-icon>arrow_upward</v-icon>
      </v-btn>      
      <v-card class="flex" flat tile color="#121212">
        <v-card-title>
          <span>Total R$ <strong class="subheading">{{pedido.valor.replace('.',',')}}</strong>
          </span>
          <v-btn
            @click="closePedidoFeito()"
            color="#EF6C00"
            dark            
            x-small
            outlined
            fab
            class="ma-2"
          >
            <v-icon>refresh</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn class="ma-2" color="teal" dark @click="continuaPedido">
            Continuar
          </v-btn>
        </v-card-title>
      </v-card>
    </v-footer>

    <!-- DIALOG OBS -->
    <v-dialog v-model="dialogObs" persistent max-width="600px">
      <v-card color="#1e1e1e" dark>
        <v-card-title>
          <span class="text-h5">Alguma observação?</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12" lg="12">
                <v-textarea label="Escreva em poucas palavras suas observações..." outlined :value="obsProduto" @change="v => obsProduto = v"></v-textarea>
              </v-col>              
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" outlined rounded @click="closeObs()">Fechar</v-btn>
          <v-btn color="teal darken-1" outlined rounded @click="saveObs()">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG ADICIONAIS -->
    <v-dialog v-model="dialogAdc" persistent style="overflow-y: clip;">
        <v-app-bar v-for="item in adicionais" :key="item.id" flat absolute dense color="#1e1e1e" dark style="border-top-right-radius: 10px;border-top-left-radius: 10px;">
        <v-toolbar-title class="category-header__title">{{item.descricao}}</v-toolbar-title>
        <v-spacer></v-spacer>
          <v-btn color="orange" icon dark @click="closeAdc()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-app-bar>
      <v-card color="#1e1e1e" dark>
        <v-row dense>
          <v-col >
            <v-card v-for="produto in produtoToAdc.adicionais" :key="produto.id" outlined elevation="1" class="product-card" color="#1e1e1e" dark>
              <v-row style="margin: 0">
                <v-col sm="12" md="2" lg="2" xs="2" xl="2" style="text-align: center;" align-self="center">
                  <v-avatar size="90px" tile class="ma-0">
                    <v-img style="border-radius: 15px;" :src="produto.urlImagem"></v-img>
                  </v-avatar>
                </v-col>
                <v-col sm="12" md="7" lg="7" xs="7" xl="7" align-self="center">
                  <v-card-title class="text-h6 product-title">{{ produto.descricao }}</v-card-title>
                  <v-card-subtitle class="product-subtitle">{{ produto.detalhes }}</v-card-subtitle>
                </v-col>
                <v-col sm="12" md="3" lg="3" xs="3" xl="3" align-self="center" style="text-align: center;">         
                  <v-card-subtitle style="padding-top: 1px;padding-bottom: 1px;">A partir de</v-card-subtitle>    
                  <h2 class="product-price">{{produto.preco}}</h2>  
                  <v-row justify="center">    
                    <v-btn class="mx-1" @click="removeAdc(produto)" fab dark small outlined color="#00BFA5">
                      <v-icon dark>remove</v-icon>
                    </v-btn>
                    <v-subheader style="font-weight: bold; font-size: 22px;">{{produto.quantidade == undefined ? 0 : produto.quantidade}}</v-subheader>
                    <v-btn class="mx-1" @click="addAdc(produto)" fab dark small outlined color="#00BFA5">
                      <v-icon dark>add</v-icon>
                    </v-btn>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" outlined rounded @click="closeAdc()">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG RESUME -->
    <template>
      <v-row justify="center" style="margin: 0">
        <v-dialog v-model="dialogResume" fullscreen transition="dialog-bottom-transition">
          <v-card color="#1e1e1e" dark>
            <v-toolbar dark color="teal darken-2">
              <v-btn icon dark @click="voltaTelaPedido()">
                <v-icon>close</v-icon>
              </v-btn>
              <v-toolbar-title>Resumo do Pedido</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn dark outlined small @click="voltaTelaPedido()">Voltar</v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-list three-line subheader color="#1e1e1e" dark>
              <v-subheader class="white--text">Itens do Pedido</v-subheader>
              <v-card v-for="item in pedido.itensPedido" :key="item.produtoId" outlined elevation="2" class="product-card" color="#1e1e1e" dark>
                <v-row>
                  <v-col sm="2" md="2" lg="2" xs="2" xl="2" style="text-align: center;" align-self="center">
                    <v-avatar size="90px" tile class="ma-2">
                      <v-img style="border-radius: 15px;" :src="item.urlImagem"></v-img>
                    </v-avatar>  
                  </v-col> 
                  <v-col sm="7" md="7" lg="7" xs="7" xl="7" align-self="center">
                    <v-card-title class="text-h6 product-title">{{ item.descricao }}</v-card-title>
                    <v-card-subtitle class="product-subtitle">{{ item.detalhes }}</v-card-subtitle>
                    <v-card-text v-if="item.observacao">Obs: {{ item.observacao }}</v-card-text>
                    <v-card-actions v-if="item.adicionais.length > 0">Adicionais:
                      <v-chip dark v-for="adc in item.adicionais" :key="adc.produtoId" color="#0277BD" class="ma-2">{{adc.descricao + ' R$ ' + adc.preco  + ' ' + adc.quantidade + 'un'}}</v-chip>
                    </v-card-actions>
                  </v-col>
                  <v-col sm="3" md="3" lg="3" xs="3" xl="3" align-self="center" style="text-align: center;">
                    <v-card-subtitle style="padding-top: 1px;padding-bottom: 1px;">Valor</v-card-subtitle>    
                    <h2 class="product-price">{{item.preco}}</h2>  
                    <v-row justify="center">    
                      <v-subheader style="font-weight: bold; font-size: 22px;">{{item.quantidade == undefined ? 0 : item.quantidade + 'un'}}</v-subheader>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card> 
              <div class="container-resumo">
                <v-footer dark v-if="exibeFooterResumo" fixed color="#121212">
                  <v-row dense justify="center">
                  <v-col sm="12" md="12" lg="12" xs="12" xl="12" align-self="center">
                    <v-card class="flex" flat tile color="#121212">
                      <v-card-text class="text-h4 py-4 white--text text-center" style="font-size: 22px">
                        <span>Total R$ <strong class="subheading">{{pedido.valor.replace('.',',')}}</strong></span>
                      </v-card-text>
                    </v-card>
                  </v-col>
                    <!-- <v-col sm="6" md="6" lg="6" xs="6" xl="6" align-self="center">
                      <v-card color="#00695C" dark @click="pagamentoPix()">
                        <v-card-title class="text-h4">Pagar Agora</v-card-title>
                        <v-card-subtitle>Apenas PIX</v-card-subtitle>
                        <v-avatar tile class="ma-2">
                          <v-icon x-large>qr_code</v-icon>
                        </v-avatar>
                      </v-card>
                    </v-col> -->
                    <v-col sm="3" md="3" lg="3" xs="3" xl="3" align-self="center">
                      <v-card color="#5E35B1" dark @click="pagamentoCaixa('DEBITO')">
                        <v-card-title class="text-h4">Débito</v-card-title>
                        <v-card-subtitle>Cartão de Débito</v-card-subtitle>
                        <v-avatar tile class="ma-2">
                          <v-icon x-large>payment</v-icon>
                        </v-avatar> 
                      </v-card>
                    </v-col>
                    <v-col sm="3" md="3" lg="3" xs="3" xl="3" align-self="center">
                      <v-card color="#0277BD" dark @click="pagamentoCaixa('CREDITO')">
                        <v-card-title class="text-h4">Crédito</v-card-title>
                        <v-card-subtitle>Cartão de Crédito</v-card-subtitle>
                        <v-avatar tile class="ma-2">
                          <v-icon x-large>payment</v-icon>
                        </v-avatar> 
                      </v-card>
                    </v-col>
                    <v-col sm="3" md="3" lg="3" xs="3" xl="3" align-self="center">
                      <v-card color="#00838F" dark @click="pagamentoPixSicoob()" :class="{ 'card-disabled': pixEmProgresso || overlay }">
                        <v-card-title class="text-h4">PIX</v-card-title>
                        <v-card-subtitle>Pagar com PIX</v-card-subtitle>
                        <v-avatar tile class="ma-2">
                          <v-icon x-large>qr_code</v-icon>
                        </v-avatar> 
                      </v-card>
                    </v-col>
                    <v-col sm="3" md="3" lg="3" xs="3" xl="3" align-self="center">
                      <v-card color="#2E7D32" dark @click="pagamentoCaixa('DINHEIRO')">
                        <v-card-title class="text-h4">Dinheiro</v-card-title>
                        <v-card-subtitle>Pagar com Dinheiro</v-card-subtitle>
                        <v-avatar tile class="ma-2">
                          <v-icon x-large>local_atm</v-icon>
                        </v-avatar> 
                      </v-card>
                    </v-col>
                  </v-row>
                </v-footer>
              </div>
            </v-list>
          </v-card>
          <v-row justify="center">
            <v-overlay :value="overlay">
              <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
          </v-row>
    
          <!-- dialog confirmação pedido caixa -->
          <v-row justify="space-around">
            <v-dialog transition="dialog-bottom-transition" max-width="600" v-model="dialogCaixa" persistent>
            <v-card color="#1e1e1e" dark>
              <v-toolbar color="#00695C" dark dense>
                  <v-toolbar-title>Pedido confirmado!</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn icon dark @click="closePedidoFeito()">
                    <v-icon>close</v-icon>
                  </v-btn>
                </v-toolbar>
                <v-card-text style="text-align: center;">
                  <div class="text-h4 pa-4" style="font-weight:bold">Pedido Nº: {{pedido.numero}}</div>
                </v-card-text>
                <v-card-text style="text-align: center;" v-if="trocoCliente!=''">
                  <div class="text-h4 pa-4" style="font-weight:bold">Troco: {{trocoCliente.replace('.',',')}}</div>
                </v-card-text>
                <v-card-text style="text-align: center;">
                  <div class="text-h5 pa-2">Dirija-se ao caixa para realizar o pagamento.</div>
                </v-card-text>
                <v-card-text class="d-flex flex-no-wrap justify-space-around">
                  <v-img src="../../assets/AiCheff.png" max-width="120px"></v-img>
                </v-card-text>
              </v-card>
            </v-dialog>
          </v-row>
          <!-- dialog para troco -->
            <v-row justify="space-around">
            <v-dialog transition="dialog-bottom-transition" max-width="350" v-model="dialogTroco" persistent>
              <v-card color="#1e1e1e" dark>
                  <v-toolbar color="#00695C" dark dense>
                    <v-toolbar-title>Pagamento em Dinheiro</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="dialogTroco=false">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-toolbar>
                <v-container>
                <v-row>
                  <v-col>
                    <v-text-field
                        v-model="dinheiroCliente"
                        label="Valor em dinheiro"
                        prefix="R$"
                        single-line
                        hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
                </v-container>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn class="ma-2" dark color="teal" @click="calcAndFinish()">Calcular e Finalizar</v-btn>
                </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
        </v-dialog>


        <v-row justify="space-around">
          <v-dialog transition="dialog-bottom-transition" max-width="600" v-model="dialogPix" persistent>
            <v-card color="#1e1e1e" dark>
              <v-toolbar color="#00695C" dark dense>
                <v-toolbar-title>Pedido confirmado!</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="closePedidoFeito()">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text  style="text-align: center;">
                <div class="text-h4 pa-4" style="font-weight:bold">Pedido Nº: {{pedido.numero}}</div>
              </v-card-text>
              <template v-if="aguardandoQrPix">
                <v-card-text class="text-center">
                  <v-progress-circular indeterminate size="48" color="teal"></v-progress-circular>
                  <div class="text-h6 mt-4">Gerando QR Code PIX...</div>
                </v-card-text>
              </template>
              <template v-else>
                <v-card-text style="text-align: center;">
                  <div class="text-h5 pa-2">QRCode PIX para pagamento:</div>
                </v-card-text>
                <v-card-title style="justify-content: center;">
                  <v-sheet color="#FFFFFF" rounded class="pa-4 d-inline-block">
                    <template v-if="qrCode64">
                      <v-img :src="qrCode64" width="240" height="240" contain></v-img>
                    </template>
                    <template v-else>
                      <qrcode-vue
                        :value="chaveCopiaeCola || 'aguardando'"
                        :size="220"
                        level="H"
                        render-as="svg"
                        :background="'#FFFFFF'"
                        :foreground="'#000000'"
                        :margin="2"
                      />
                    </template>
                  </v-sheet>
                </v-card-title>
              </template>
              <v-card-text class="text-center">
                <div class="text-h6">Tempo para pagar</div>
                <div class="display-1" style="font-weight: bold;">{{ formatCountdown(countdownPix) }}</div>
                <div class="pa-2 grey--text text--lighten-1" style="font-size: 12px;">A cobrança expira em 1 minuto e 59 segundos</div>
              </v-card-text>
              <v-card-text style="text-align: center;">
                <div class="text-h5 pa-2">Aponte a câmera do banco para o QR Code</div>
                <div class="pa-2 grey--text text--lighten-1" style="font-size: 13px;">Iluminação adequada e fundo claro melhoram a leitura</div>
              </v-card-text>
              <v-card-text class="d-flex flex-no-wrap justify-space-around">
                <v-img src="../../assets/AiCheff.png" max-width="120px"></v-img>
              </v-card-text>
              <v-card-actions class="justify-center pb-6">
                <v-btn color="red darken-1" outlined rounded @click="cancelPix('Pagamento cancelado pelo cliente')">Cancelar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>

        <!-- dialog confirmação de pagamento PIX -->
        <v-row justify="space-around">
          <v-dialog transition="dialog-bottom-transition" max-width="600" v-model="dialogPixPago" persistent>
            <v-card color="#1e1e1e" dark>
              <v-toolbar color="#2E7D32" dark dense>
                <v-toolbar-title>Pagamento confirmado!</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="fecharPixPago()">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text style="text-align: center;">
                <div class="text-h5 pa-2">Seu pedido está em preparação.</div>
                <div class="pa-2 grey--text text--lighten-1" style="font-size: 13px;">Avisaremos quando estiver pronto para retirada.</div>
              </v-card-text>
              <v-card-text class="text-center">
                <div class="text-h6">Voltando ao cardápio em</div>
                <div class="display-1" style="font-weight: bold;">{{ formatCountdown(timerPixPago) }}</div>
              </v-card-text>
              <v-card-actions class="justify-center pb-6">
                <v-btn color="teal" outlined rounded @click="fecharPixPago()">Fechar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </v-row>
    </template>

    <v-dialog transition="dialog-bottom-transition" max-width="600" v-model="exibeImagemItem">
      <v-card>
        <v-toolbar color="#00695C" dark dense>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="exibeImagemItem = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text style="text-align: center; margin: 10 auto">
          <br>
          <img :src="imagemItem" width="550px">
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="dialogoPerguntaTerminal" max-width="600px">
      <v-card color="#1e1e1e" dark>
        <v-toolbar color="#00695C" dark dense>
          <v-card-title>Onde deseja imprimir?</v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialogoPerguntaTerminal = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text style="padding-bottom: 0px">
          <v-container fluid grid-list-md>
            <v-row>
              <v-col cols="12" v-for="terminal in terminais" :key="terminal.id">
                <v-btn block outlined color="teal" dark @click="dialogoPerguntaTerminal = false; salvarPedido(terminal.enderecoMac)">{{ terminal.nome }}</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-row justify="center">
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-row>

    <v-snackbar v-model="snackbar" :timeout="timeout"      
      shaped
      top
      color="#FB8C00" 
      style="text-align: center;" 
      centered>
      {{ textoSnackbar }}
    </v-snackbar>
    <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </div>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  /* import vueCard from 'vue-card-express'; */
  // Import stylesheet
  //import {QrCodePix} from 'qrcode-pix'
  import 'vue-loading-overlay/dist/vue-loading.css';
  import QrcodeVue from 'qrcode.vue'
  import { baseApiUrl } from '@/global'
  import Snackbar from '../../componentes/snackbar.vue'
  import {
    mapState
  } from 'vuex'
  import moment from 'moment'
  import axios from 'axios'
  export default {
    components: {
      Snackbar,
      QrcodeVue,
      Loading
    },
    name: 'Auth',
    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
    }),
    data: function () {
      return {
        categoriaAtivaId: null,
        categoriaInitialId: null,
        updateKey: 0,
        timeout: 4000,
        snackbar: false,
        textoSnackbar: '',
        localPagamento: '',      
        mask: "###.###.###-##",
        maskCartao: "#### #### #### ####",
        pagamento: {
          cartaoNumero: '',
          cvv: '',
          mesVencimento: '',
          anoVencimento: '',
          nomeTitular: '',
          cpfTitular: '',
          bandeira: '',
        },        
        dialog: false,
        confirmacaoBoleto: false,       
        modelCartao: {
          id: '',
          valor: '',
          tipoTransacao: 'A_VISTA',
          quantidadeParcelas: 1,
          comprador: {
            id: '',
            documentoNumero: '',
            documentoTipo: '1',
            email: '',
            nomeCompleto: '',
            primeiroNome: '',
            ultimoNome: '',
            enderecoLogradouro: '',
            enderecoNumero: '',
            enderecoComplemento: '',
            enderecoCep: '',
            enderecoBairro: '',
            enderecoCidade: '',
            enderecoEstado: '',
          },
          cartao: {
            numero: '',
            codigoSeguranca: '',
            nome: '',
            expiracaoAno: '',
            expiracaoMes: '',
            bandeira: ''
          }
        },
        modelPix: {
          customer: '',
          billingType: 'PIX',
          value: 0,
          dueDate: '',
          description: '',
          externalReference: '',
          installmentCount: '',
          installmentValue: '',
          discount: [],
          interest: [],
          fine: [],
          postalService: false,
          split: []
        },
        qrCode64: '',
        chaveCopiaeCola: '',
        empresa: [],
        obsProduto: '',
        adcProduto: [],
        produtoObs: '',
        produtoToAdc: [],
        timerPedido: '',
        dialogObs: false,
        dialogAdc: false,
        dialogResume: false,
        exibeFooterResumo: false,
        overlay: false,
        dialogCaixa: false,
        dialogTroco: false,
        dialogPix: false,
        pagamentoPix: false,
        pixEmProgresso: false,
        // Contagem regressiva do PIX (1m59s)
        countdownPix: 0,
        countdownInterval: null,
        aguardandoQrPix: false,
        // Modal de pagamento PIX aprovado
        dialogPixPago: false,
        timerPixPago: 13,
        intervalPixPago: null,
        dinheiroCliente: '',
        trocoCliente: '',
        produtos: [],
        categorias: [],
        adicionais: [],
        qtdAdicional: 0,
        itemAdicional: {
          quantidade: 0,
          produtoId: '',
          descricao: '',
          urlImagem: '',
          detalhes: '',
          preco: '',
        },
        itemAdicionalDefault: {
          quantidade: 0,
          produtoId: '',
          descricao: '',
          urlImagem: '',
          detalhes: '',
          preco: '',
        },
        itemPedido: {
          quantidade: 0,
          produtoId: '',
          descricao: '',
          urlImagem: '',
          detalhes: '',
          preco: '',
          adicionais: []
        },
        itemPedidoDefault: {
          quantidade: 0,
          produtoId: '',
          descricao: '',
          urlImagem: '',
          detalhes: '',
          preco: '',
          adicionais: []
        },
        pedidoDefault: {
          numero: 0,
          statusPedido: "EM ANÁLISE",
          formaPagamento: "",
          statusPagamento: "PENDENTE",
          valor: "0,00",
          desconto: "",
          empresaId: "62ab6e94853c213ed69cf2ff",
          itensPedido: [],
          created: '',
          enderecoMac: '',
        },
        pedido: {
          numero: 0,
          statusPedido: "EM ANÁLISE",
          formaPagamento: "",
          statusPagamento: "PENDENTE",
          valor: "0,00",
          desconto: "",
          empresaId: "62ab6e94853c213ed69cf2ff",
          itensPedido: [],
          created: '',
          enderecoMac: '',
        },
        // Armazena o id do pedido salvo para usar nas consultas de pagamento
        pedidoIdConsulta: '',
        isLoading: false,
        fullPage: true,
        jaExiste: false,
        codigoExistente: '',
        msgResultado: '',
        idInscricao: '',
        codigoAcesso: '',
        informaMunicipio: true,
        imagemItem: '',
        exibeImagemItem: false,
        dialogoPerguntaTerminal: false,
        terminais: [],
        enderecoMacUrl: '',
        dictionary: {
          custom: {
            nomeCartao: {
              required: () => 'Informe o nome'
            },
            numCartao: {
              required: () => 'Informe o número do cartão de crédito',
            },
            cpftitular: {
              required: () => 'Informe o número do cartão de crédito',
            },
            codCartao: {
              required: () => 'Informe o código de segurança'
            },
            expiraCartaoMes: {
              required: () => 'Informe o mês de validade do cartão',
            },
            expiraCartaoAno: {
              required: () => 'Informe o ano de validade do cartão',
            },
          }
        }
      }
    },
    mounted: function () {
      this.pegaParametrosUrl()
      this.carregaDados()
      this.carregaEmpresa()
      this.$validator.localize('pt', this.dictionary)
    },
    watch: {
      dialogCaixa(val) {
        if (val === false) {
          // garante que nenhum timer residual dispare após fechar o modal do caixa
          if (this.timerPedido) { clearTimeout(this.timerPedido); this.timerPedido = null }
        }
      }
    },

    methods: {
      exibeImagem(urlImagem) {
        this.imagemItem = urlImagem
        this.exibeImagemItem = true
      },

      filterProductsbyCategoria(categoriaId) {
        return this.produtos.filter(produto => produto.categoriaId === categoriaId)
      },

      filterAdicionaisbyProduct(){
        return this.produtoToAdc.adicionais
      },


      clearAllTimers(){
        if (this.timerPedido) { clearTimeout(this.timerPedido); this.timerPedido = null }
        if (this.countdownInterval) { clearInterval(this.countdownInterval); this.countdownInterval = null }
        if (this.verificaPagamento) { clearInterval(this.verificaPagamento); this.verificaPagamento = null }
        if (this.intervalPixPago) { clearInterval(this.intervalPixPago); this.intervalPixPago = null }
      },

      closePedidoFeito(){
        // Limpa timers/intervalos pendentes para evitar refresh automático depois
        this.clearAllTimers()
        this.pedido = Object.assign({}, this.pedidoDefault)
        this.pedido.itensPedido = []
        this.produtoToAdc = []
        this.produtos = []
        this.itemPedido = Object.assign({}, this.itemPedidoDefault)
        this.itemPedido.adicionais = []
        this.carregaDados()
        this.dialogCaixa = false
        this.dialogPix = false
        this.dialogResume = false
        this.trocoCliente = ''
        this.dinheiroCliente = ''
        this.scrollToClass()
      },

      closeDialogPix(){
        // não recarrega a página para evitar refresh automático
        this.dialogPix = false
      },

      getTotalQuantidade(categoriaId) {
        return this.filterProductsbyCategoria(categoriaId).reduce((total, produto) => total + produto.quantidade, 0);
      },

      scrollToClass() {
        window.scroll({
          top: 0,
          behavior: 'smooth'
        });
        this.categoriaAtivaId = this.categoriaInitialId
        this.updateKey++
      },

      async carregaEmpresa() {
        await axios.get(`${baseApiUrl}Empresas/62ab6e94853c213ed69cf2ff`).then(res => {
          if (res.data) {
            this.empresa = res.data
          }
        })
      },

      async carregaDados() {
        this.produtos = []
        this.overlay = true
        await axios.get(`${baseApiUrl}Categorias?filter={"where":{"and":[{"empresaId":"62ab6e94853c213ed69cf2ff"},{"status":true}]}}`)
            .then(res => {
                    this.categorias = res.data.filter(cat => cat.descricao != 'ADICIONAIS')
                    this.adicionais = res.data.filter(cat => cat.descricao == 'ADICIONAIS')
                    this.categorias.sort(this.ordenaItens)
                })
        await axios.get(`${baseApiUrl}Produtos?filter={"where":{"and":[{"empresaId":"62ab6e94853c213ed69cf2ff"},{"status":"true"}]},"include":"categoria"}`)
          .then(res => {
                    this.produtos = res.data
                    this.produtos.sort(this.ordenaItens)
                    this.overlay = false
                    this.produtos.forEach(produto => {
                      if(produto.categoria.descricao != 'ADICIONAIS')
                          produto.adicionais = this.produtos.filter(prod => prod.categoria.descricao == 'ADICIONAIS')
                      produto.quantidade = 0
                    });
                    //this.produtos.adicionais = this.produtos.filter(prod => prod.categoria.descricao == 'ADICIONAIS')
              })    
              
              const categoriaAtiva = this.categorias.find(categoria => {
                  return this.filterProductsbyCategoria(categoria.id).length > 0;
              });
              if (categoriaAtiva) {
                  this.categoriaAtivaId = categoriaAtiva.descricao;
                  this.categoriaInitialId = categoriaAtiva.descricao;
              }
              this.updateKey++;
        },

      ordenaItens(a,b){
        if (a.ordem > b.ordem) {
            return 1;
          }
          if (a.ordem < b.ordem) {
            return -1;
          }
          // a must be equal to b
        return 0;
      },

      async pagamentoCaixa(formaSelecionada){
        // Limpa timers ativos (de PIX ou confirmadores) para não haver refresh posterior
        if (this.timerPedido) { clearTimeout(this.timerPedido); this.timerPedido = null }
        if (this.countdownInterval) { clearInterval(this.countdownInterval); this.countdownInterval = null }
        if (this.verificaPagamento) { clearInterval(this.verificaPagamento); this.verificaPagamento = null }
        this.pedido.formaPagamento = formaSelecionada
        this.pedido.numero = await this.retornaNumeroPedido()
        /* if(formaSelecionada == 'DINHEIRO')
          this.dialogTroco = true
        else{ */
        this.overlay = true
        if (this.enderecoMacUrl) {
          this.salvarPedido(this.enderecoMacUrl)
        } else {
          // para métodos não PIX, buscar terminal e salvar automaticamente se houver só um
          await this.pegaTerminais(true, true)
          if (!this.dialogoPerguntaTerminal && this.pedido.enderecoMac) {
            this.salvarPedido(this.pedido.enderecoMac)
          }
        }
        // this.salvarPedido(formaSelecionada)
        /* } */
      },

      async retornaNumeroPedido() {
        let numero = ''

        await axios.get(baseApiUrl + 'Pedidos?filter={"where":{"and":[{"empresaId":"62ab6e94853c213ed69cf2ff"},{"created":{"gt":"' + moment().format('YYYY-MM-DD') + 'T00:00:00.000Z"}},{"created":{"lt":"' + moment().format('YYYY-MM-DD') + 'T23:59:59.000Z"}}]}, "order":"numero DESC", "fields": {"numero": true}}')
        .then(response => {
          if (response.data.length > 0) {
            numero = response.data[0].numero + 1
          } else {
            numero = 1
          }
        })

        return numero
      },

      calcAndFinish(){
        if(this.dinheiroCliente != '' && parseFloat(this.dinheiroCliente) > parseFloat(this.pedido.valor.replace(',', '.'))){
          this.overlay = true
          this.pegaTerminais()
          //this.salvarPedido(this.pedido.formaPagamento)
        }
        else{
          this.snackbar = true
          this.textoSnackbar = "O Valor em dinheiro não pode ser menor que o valor total!"
        }
      },

      // mantendo apenas o fluxo PIX Sicoob

      async pagamentoPixSicoob() {
        if (this.pixEmProgresso || this.overlay) return
        if (this.pedido.itensPedido.length === 0) {
          this.snackbar = true
          this.textoSnackbar = 'Adicione um item para continuar'
          return
        }
        try {
          this.pixEmProgresso = true
          this.pedido.formaPagamento = 'PIX'
          this.pedido.numero = await this.retornaNumeroPedido()
          // abre o modal imediatamente e mostra spinner interno até o QR chegar
          this.aguardandoQrPix = true
          this.dialogPix = true
          // mantém overlay logo após abrir o modal por um tick para bloquear o toque inicial
          this.overlay = true
          // Garante MAC: se não vier por URL, pergunta ou usa o primeiro terminal disponível
          if (!this.enderecoMacUrl) {
            // no fluxo PIX apenas seleciona o terminal sem salvar pedido aqui
            await this.pegaTerminais(false, false)
          }
          // salva pedido em modo silencioso e captura o objeto salvo (com id)
          const pedidoSalvo = await this.salvarPedido(this.enderecoMacUrl, true)

          const valor = parseFloat(this.pedido.valor.replace(',', '.')).toFixed(2)
          const dados = {
            empresaId: '62ab6e94853c213ed69cf2ff',
            valor: valor,
            descricao: `Pedido #${this.pedido.numero}`,
            pedidoId: (pedidoSalvo && pedidoSalvo.id) ? pedidoSalvo.id : this.pedido.id,
            devedor: {
              cpf: '07229600421',
              nome: 'Cliente Totem'
            }
          }
          // guarda o id do pedido para consultas subsequentes
          this.pedidoIdConsulta = (pedidoSalvo && pedidoSalvo.id)
            ? pedidoSalvo.id
            : (this.pedido && this.pedido.id ? this.pedido.id : '')
          const res = await axios.post(`${baseApiUrl}Pagamentos/sicoobCobranca`, dados)
          if (res.data) {
            this.qrCode64 = res.data.imagemQrcode
              ? (res.data.imagemQrcode.startsWith('data:') ? res.data.imagemQrcode : `data:image/png;base64,${res.data.imagemQrcode}`)
              : ''
            const empresaNome = (this.empresa && this.empresa.nome) ? this.empresa.nome : 'AI Cheff'
            this.chaveCopiaeCola = res.data.brcode || res.data.qrcode || this.buildBrcodeFromLocation(res.data.location, valor, empresaNome, 'PED' + this.pedido.numero) || ''
            this.pagamentoPix = true
            // só libera overlay após o dialog abrir
            this.$nextTick(() => { this.overlay = false; this.aguardandoQrPix = false })
            this.pixEmProgresso = false
            this.startPixCountdown()
            this.consultaPagamentoPixSicoob()
          } else {
            this.overlay = false
            this.aguardandoQrPix = false
            this.pixEmProgresso = false
            this.snackbar = true
            this.textoSnackbar = 'Falha ao gerar pagamento. Tente novamente mais tarde.'
          }
        } catch (e) {
          this.overlay = false
          this.aguardandoQrPix = false
          this.pixEmProgresso = false
          this.snackbar = true
          this.textoSnackbar = 'Falha ao gerar pagamento. Tente novamente mais tarde.'
        }
      },

      async consultaPagamentoPixSicoob() {
        try {
          this.verificaPagamento = setInterval(async () => {
            const pedidoId = this.pedidoIdConsulta || (this.pedido && this.pedido.id) || ''
            // envia por query string (compat com LoopBack) e também no corpo
            const res = await axios.post(`${baseApiUrl}Pagamentos/sicoobCobrancaConsulta?pedidoId=${encodeURIComponent(pedidoId)}`, { pedidoId })
            if (res.data && res.data.status === 'APPROVED') {
              // pagamento confirmado: encerra timers e limpa loads
              if (this.countdownInterval) clearInterval(this.countdownInterval)
              if (this.verificaPagamento) clearInterval(this.verificaPagamento)
              this.isLoading = false
              this.dialogPix = false
              // Exibe modal dedicado de confirmação PIX com contador 13s
              this.abrirPixPago()
            }
          }, 5000)
        } catch (error) {
          clearInterval(this.verificaPagamento)
          this.isLoading = false
          this.snackbar = true
          this.textoSnackbar = 'Não foi possível verificar o pagamento, tente novamente!'
        }
      },

      startPixCountdown() {
        // 1 minuto e 59 segundos = 119s
        this.countdownPix = 119
        if (this.countdownInterval) clearInterval(this.countdownInterval)
        this.countdownInterval = setInterval(() => {
          if (this.countdownPix > 0) {
            this.countdownPix = this.countdownPix - 1
          }
          if (this.countdownPix <= 0) {
            this.cancelPix('Tempo esgotado para pagamento')
          }
        }, 1000)
      },

      cancelPix(motivo) {
        if (this.countdownInterval) clearInterval(this.countdownInterval)
        if (this.verificaPagamento) clearInterval(this.verificaPagamento)
        this.dialogPix = false
        this.pagamentoPix = false
        this.isLoading = false
        this.overlay = false
        this.pixEmProgresso = false
        if (motivo) {
          this.snackbar = true
          this.textoSnackbar = motivo
        }
      },

      abrirPixPago() {
        // inicia modal e countdown de 13s
        this.dialogPixPago = true
        this.timerPixPago = 13
        if (this.intervalPixPago) clearInterval(this.intervalPixPago)
        this.intervalPixPago = setInterval(() => {
          if (this.timerPixPago > 0) this.timerPixPago = this.timerPixPago - 1
          if (this.timerPixPago <= 0) this.fecharPixPago()
        }, 1000)
      },

      fecharPixPago() {
        if (this.intervalPixPago) clearInterval(this.intervalPixPago)
        this.intervalPixPago = null
        this.dialogPixPago = false
        // volta ao cardápio
        this.closePedidoFeito()
      },

      formatCountdown(totalSeconds) {
        const s = Math.max(0, parseInt(totalSeconds || 0, 10))
        const m = Math.floor(s / 60)
        const r = s % 60
        return `${m.toString().padStart(1,'0')}:${r.toString().padStart(2,'0')}`
      },


      async salvarPedido(enderecoMac, silent = false){
        if (enderecoMac) {
          this.pedido.enderecoMac = enderecoMac
        }
        try {
          this.pedido.created = moment().format().replace('-03:00', '.000Z')
          // não remover urlImagem; é usada na tela de resumo
          let res = await axios.post(`${baseApiUrl}Pedidos/replaceOrCreate`, this.pedido)
          if(res.status == 200){
              if (res.data) {
                this.pedido = res.data
              }
              this.overlay = false
              if (!silent) {
                // Exibe modal "dirija-se ao caixa" somente quando NÃO for PIX
                if (this.pedido.formaPagamento !== 'PIX') {
                  this.dialogCaixa = true
                  // fecha automaticamente após 13s para voltar ao cardápio, sem refresh
                  if (this.timerPedido) clearTimeout(this.timerPedido)
                  this.timerPedido = setTimeout(() => {
                    this.dialogCaixa = false
                    this.closePedidoFeito()
                  }, 13000)
                }
              }
              return res.data
          }
          else
          {
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao finalizar o pedido, tente novamente", "ERRO")
            return null
          }
        } catch (error) {
            this.overlay = false
            vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao finalizar o pedido, tente novamente", "ERRO")
            return null
        }
      },

      addProduto(produto){
        this.overlay = true  
        this.itemPedido = Object.assign({}, this.itemPedidoDefault)
        this.itemPedido.adicionais = []
        if(this.pedido.itensPedido.length == 0){
          this.itemPedido.quantidade = this.itemPedido.quantidade + 1
            produto.quantidade = this.itemPedido.quantidade
            this.itemPedido.produtoId = produto.id      
            this.itemPedido.descricao = produto.descricao
            this.itemPedido.urlImagem = produto.urlImagem
            this.itemPedido.detalhes = produto.detalhes
            this.itemPedido.preco = produto.preco
            this.pedido.itensPedido.push(this.itemPedido)
        }
        else
        {
          this.pedido.itensPedido.forEach(item => {
              if(item.produtoId == produto.id){
                item.quantidade = item.quantidade + 1
                produto.quantidade = item.quantidade
              }
              else
                if(!this.pedido.itensPedido.find(({produtoId}) => produtoId === produto.id)){
                  this.itemPedido.quantidade = this.itemPedido.quantidade + 1
                  produto.quantidade = this.itemPedido.quantidade
                  this.itemPedido.produtoId = produto.id      
                  this.itemPedido.descricao = produto.descricao
                  this.itemPedido.urlImagem = produto.urlImagem
                  this.itemPedido.detalhes = produto.detalhes
                  this.itemPedido.preco = produto.preco
                  this.pedido.itensPedido.push(this.itemPedido) 
                }
                
          })
            
        }
          this.pedido.valor = (parseFloat(this.pedido.valor.replace(',', '.')) + parseFloat(produto.preco.replace(',', '.'))).toFixed(2)
          this.overlay = false
          // Ao adicionar produto, certifique-se de não deixar diálogos e timers PIX ativos
          if (this.dialogPix) this.cancelPix()
      },

      addAdc(produto){     
        this.overlay = true
          if(this.pedido.itensPedido.length > 0){
            this.pedido.itensPedido.forEach(item => {
              this.itemAdicional = Object.assign({}, this.itemAdicionalDefault)
            if(item.adicionais.length > 0 && item.produtoId == this.produtoToAdc.id){
              item.adicionais.forEach(adicional => {
                if(adicional.produtoId == produto.id && this.produtoToAdc.id == item.produtoId){
                    adicional.quantidade = adicional.quantidade + 1
                    this.produtos.forEach(prod => {
                      if(this.produtoToAdc.id == prod.id)
                          prod.adicionais.forEach(adc => {
                            if(adc.id == produto.id && this.produtoToAdc.id == prod.id)
                                adc.quantidade = adicional.quantidade
                          });
                    });
                }  
                else
                if(!item.adicionais.find(({produtoId}) => produtoId === produto.id))
                  {
                      this.itemAdicional.quantidade = this.itemAdicional.quantidade + 1
                      this.itemAdicional.produtoId = produto.id      
                      this.itemAdicional.descricao = produto.descricao
                      this.itemAdicional.urlImagem = produto.urlImagem
                      this.itemAdicional.detalhes = produto.detalhes
                      this.itemAdicional.preco = produto.preco
                      item.adicionais.push(this.itemAdicional) 
                      this.produtos.forEach(prod => {
                        if(this.produtoToAdc.id == prod.id)
                          prod.adicionais.forEach(adc => {
                            if(adc.id == produto.id && this.produtoToAdc.id == prod.id)
                                adc.quantidade = this.itemAdicional.quantidade
                          });
                    });
                  }              
              });
              }
              else
              if(this.produtoToAdc.id === item.produtoId && item.adicionais.length == 0){
                this.itemAdicional.quantidade = this.itemAdicional.quantidade + 1
                  this.itemAdicional.produtoId = produto.id      
                  this.itemAdicional.descricao = produto.descricao
                  this.itemAdicional.urlImagem = produto.urlImagem
                  this.itemAdicional.detalhes = produto.detalhes
                  this.itemAdicional.preco = produto.preco
                  item.adicionais.push(this.itemAdicional) 
                  this.produtos.forEach(prod => {
                    if(this.produtoToAdc.id == prod.id)
                        prod.adicionais.forEach(adc => {
                          if(adc.id == produto.id && this.produtoToAdc.id == prod.id)
                              adc.quantidade = this.itemAdicional.quantidade
                        });
                  });
              }
          })
        }
        this.pedido.valor = (parseFloat(this.pedido.valor.replace(',', '.')) + parseFloat(produto.preco.replace(',', '.'))).toFixed(2)
        this.overlay = false
      },

      removeAdc(produto){
          if(this.pedido.itensPedido.length > 0){
            this.pedido.itensPedido.forEach(item => {
              if(item.adicionais.length > 0){
                this.overlay = true
                item.adicionais.forEach(adicional => {
                  if(adicional.produtoId == produto.id && adicional.quantidade > 1 && item.produtoId == this.produtoToAdc.id){
                        adicional.quantidade = adicional.quantidade - 1
                        this.produtos.forEach(prod => {
                          if(this.produtoToAdc.id == prod.id)
                            prod.adicionais.forEach(adc => {
                              if(adc.id == produto.id && this.produtoToAdc.id == prod.id)
                                  adc.quantidade = adicional.quantidade
                            });
                        });
                        this.pedido.valor = (parseFloat(this.pedido.valor.replace(',', '.')) - parseFloat(produto.preco.replace(',', '.'))).toFixed(2)
                        this.overlay = false
                    }
                    else
                      if(adicional.produtoId == produto.id && adicional.quantidade == 1 && item.produtoId == this.produtoToAdc.id){
                        item.adicionais = item.adicionais.filter(prod => prod.produtoId != produto.id)
                          this.produtos.forEach(prod => {
                            if(this.produtoToAdc.id == prod.id)
                              prod.adicionais.forEach(adc => {
                                if(adc.id == produto.id && this.produtoToAdc.id == prod.id)
                                    adc.quantidade = 0
                              });
                          });
                          this.pedido.valor = (parseFloat(this.pedido.valor.replace(',', '.')) - parseFloat(produto.preco.replace(',', '.'))).toFixed(2)
                          this.overlay = false
                      }                
                })
              }
            })
        }
      },

      openDialogObs(produto) {
        if (produto.quantidade > 0) {
          this.dialogObs= true
          this.produtoObs = produto
          this.pedido.itensPedido.forEach(item => {
            if (item.produtoId == this.produtoObs.id && item.observacao != '') {
              this.obsProduto = item.observacao
            }
          })
        } else {
          this.snackbar = true
            this.textoSnackbar = "Adicione " + produto.descricao + " para incluir observação"
        }
      },

      openDialogAdc(produto) {
        this.qtdAdicional = 0
        this.produtoToAdc = []
        if(produto.quantidade > 0) {
          this.produtoToAdc = produto
          this.pedido.itensPedido.forEach(item => {
            
            if(item.produtoId == produto.id && item.adicionais.length > 0){
                item.adicionais.forEach(adicional => {
                  for (let index = 0; index < this.produtoToAdc.adicionais.length; index++) {
                    if(adicional.quantidade > 0 && adicional.produtoId == this.produtoToAdc.adicionais[index].id && this.produtoToAdc.id == item.produtoId)
                        this.produtoToAdc.adicionais[index].quantidade = adicional.quantidade
                    else
                        this.produtoToAdc.adicionais[index].quantidade = 0
                  }
                });
            }
            else{
              if(!this.produtoToAdc.adicionais.find(({produtoId}) => produtoId === produto.id) && item.produtoId == produto.id){
                  this.produtoToAdc.adicionais.forEach(adicional => {
                    adicional.quantidade = 0                
                  });
              }
            }         
          });
              this.dialogAdc = true
        } else {
          this.snackbar = true
          this.textoSnackbar = "Adicione " + produto.descricao + " para incluir adicional"
        }
      },


      closeObs(){              
        this.dialogObs= false
        this.obsProduto = ''
      },

      closeAdc(){              
        this.dialogAdc= false
        //this.obsProduto = ''
      },

      saveObs(){
        if(this.obsProduto != undefined){
        this.pedido.itensPedido.forEach(item => {
              if(item.produtoId == this.produtoObs.id){
                  item.observacao = this.obsProduto
                  this.closeObs()
              }
            })
        }
      },

      continuaPedido() {
        if (this.pedido.itensPedido.length > 0) {
          this.dialogResume = true
          this.exibeFooterResumo = true
        } else {
            this.snackbar = true
            this.textoSnackbar = "Adicione um item para continuar"
        }
      },

      voltaTelaPedido(){
          this.exibeFooterResumo = false
          this.dialogResume = false
      },

      removeProduto(produto){
          if(this.pedido.itensPedido.length > 0){
            this.overlay = true
            this.pedido.itensPedido.forEach(item => {
              if(item.produtoId == produto.id && item.quantidade > 1){
                  item.quantidade = item.quantidade - 1
                  produto.quantidade = item.quantidade
                  this.pedido.valor = (parseFloat(this.pedido.valor) - parseFloat(produto.preco.replace(',','.'))).toFixed(2)
                  this.overlay = false                  
              }
              else
                if(item.produtoId == produto.id && item.quantidade == 1){                  
                    if(item.adicionais.length > 0){
                      this.pedido.valor = (parseFloat(this.pedido.valor) - parseFloat(produto.preco.replace(',','.')) - parseFloat(this.removeValorAdicional(item.adicionais))).toFixed(2).replace('-','')
                      this.overlay = false
                    }
                    else{
                      this.pedido.valor = parseFloat(parseFloat(this.pedido.valor) - parseFloat(produto.preco.replace(',','.'))).toFixed(2)                
                      this.overlay = false
                    }
                  this.pedido.itensPedido = this.pedido.itensPedido.filter(prod => prod.produtoId != produto.id)
                  produto.quantidade = 0
                }

          })        
        }
      },

      removeValorAdicional(item){
        let valor = "0,00";
        item.forEach(adicional => {
          valor = (parseFloat(valor.replace(',','.')) + parseFloat(adicional.preco.replace(',','.') * adicional.quantidade)).toFixed(2)          
        });
        return valor
      },

      formatDate(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDatePadrao(date) {
        if (!date) return null

        const [day, month, year] = date.substr(0, 10).split('/')
        return `${year}-${month}-${day}` + " " + date.substr(11, 6)
      },

      formatDateBrz(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDateHora(date) {
        if (!date) return null

        const [year, month, day] = date.substr(0, 10).split('-')
        return `${day}/${month}/${year}` + " " + date.substr(11, 8)
      },
      // método de pagamento
      async pagarCartao() {
        if ((this.pagamento.nomeTitular != '') && (this.pagamento.cartaoNumero != '') && (this.pagamento.cpfTitular != '') && (this.pagamento.cvv != '') && (this.pagamento.mesVencimento != '') && (this.pagamento.anoVencimento != '') && (this.pagamento.bandeira != '')) {
          await this.realizarInscricao()
          if (this.idInscricao) {
            this.isLoading = true
            var primeiroUltimoNome = this.inscricao.nome.trim().split(" ")
            this.modelCartao.id = this.encrypt(this.inscricao.cod_incricao.toString())
            this.modelCartao.tipoTransacao = 'A_VISTA'
            this.inscricao.valorPago = this.valorEvento
            this.modelCartao.valor = parseFloat(this.valorEvento.replace(',','.'))
            //dados do comprador
            this.modelCartao.comprador.id = this.encrypt(this.inscricao.cod_incricao.toString())
            this.modelCartao.comprador.documentoNumero = this.inscricao.cpf.replace(/[^\d]+/g,'')
            this.modelCartao.comprador.documentoTipo = '1'
            this.modelCartao.comprador.email = this.inscricao.email
            this.modelCartao.comprador.nomeCompleto = this.inscricao.nome
            this.modelCartao.comprador.primeiroNome = primeiroUltimoNome[0]
            this.modelCartao.comprador.ultimoNome = primeiroUltimoNome[primeiroUltimoNome.length - 1]
            this.modelCartao.comprador.enderecoLogradouro = "Rua Professor Joaquim Francisco Veloso Galvao"
            this.modelCartao.comprador.enderecoNumero = "1734"
            this.modelCartao.comprador.enderecoComplemento = "Igreja da Liberdade"
            this.modelCartao.comprador.enderecoCep = "58031130"
            this.modelCartao.comprador.enderecoBairro = "EXPEDICIONARIOS"
            this.modelCartao.comprador.enderecoCidade = "JOAO PESSOA"
            this.modelCartao.comprador.enderecoEstado = "PARAIBA"
            // this.modelCartao.comprador.telefone = this.financialManagers.cellPhone
            this.modelCartao.cartao.nome = this.pagamento.nomeTitular
            // this.modelCartao.cartao.numero = this.pagamento.cartaoNumero.replace(/[^\d]+/g,'')
            this.modelCartao.cartao.codigoSeguranca = this.pagamento.cvv
            this.modelCartao.cartao.expiracaoMes = this.pagamento.mesVencimento
            this.modelCartao.cartao.expiracaoAno = this.pagamento.anoVencimento
            this.modelCartao.cartao.bandeira = this.pagamento.bandeira

            //Pega hash cvv e salva no FM
            /* try {
              let res = await axios.post(`${baseApiUrl}FinancialManagers/encrypt`,{"text": this.modelCartao.cartao.codigoSeguranca})
              if(res.data.encrypt != '')
                this.financialManagers.cardCvc = res.data.encrypt
            } catch (error) {
              this.isLoading = false
              vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao processar solicitação, tente mais tarde!","ERRO");
              return;
            } */

            // dados para a inscrição
            this.inscricao.cardCvv = this.encrypt(this.pagamento.cvv.toString())
            this.inscricao.cardNumber = this.pagamento.cartaoNumero.replace(/[^\d]+/g,'')
            this.inscricao.cardValidity = this.pagamento.mesVencimento + this.pagamento.anoVencimento
            this.inscricao.cardHolderName = this.pagamento.nomeTitular
            this.inscricao.cardFlag = this.pagamento.bandeira
            this.atualizaInscricao()
            try {
              let res = await axios.post(`${baseApiUrl}Pagamentos/cartaocredito`, this.modelCartao) 
              if (res.data) {
                this.inscricao.codigoTransacao = res.data.transacao.autorizacaoCodigo
                this.inscricao.nsu = res.data.transacao.nsu
                this.inscricao.paymentId = res.data.pagamentoId
                this.inscricao.formOfPayment = 'CARTAO'
                this.inscricao.statusPagamento = "PAGO"
                await this.atualizaInscricao()
              }
            } catch (error) {
              this.isLoading = false
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao efetuar pagamento, " + error.response.data.error.mensagem,"DESCULPE!")
            }
            /* await axios.post("https://p4x.srv.br/api/v1.0/pagamentos/cartaocredito",this.modelCartao, { */
          } else {
            this.isLoading = false
            var vm4 = this;
            vm4.$refs.chamaSnackbar.snack("#EF5350", "Falha ao realizar inscrição, tente novamente!", "DESCULPE")
          }
        } else {
          this.$validator.validateAll()
        }
      },


      async pagarPix() {
        this.isLoading = true
        this.inscricao.statusPagamento = 'PENDENTE'
        this.inscricao.formOfPayment = 'PIX'
        await this.realizarInscricao()
        if (this.idInscricao) {
          try {
            this.modelPix.customer = this.empresa.idAsaas
            this.modelPix.value = parseFloat(this.valorEvento.replace(',','.'))
            this.modelPix.dueDate = moment().format('YYYY-MM-DD')
            this.modelPix.billingType = 'PIX'
            this.modelPix.description = 'Ref. ao evento ' + this.cultoSelecionado + " para a insc. de nº " + this.inscricao.cod_incricao
            await axios.post(`${baseApiUrl}Pagamentos/AsaasCobranca`, this.modelPix).then(res => {
              this.inscricao.paymentId = res.data.id
              this.atualizaInscricao()
              if (res.data) {
                axios.post(`${baseApiUrl}Pagamentos/AsaasQrCode`, {"id": res.data.id}).then(res2 => {
                  if (res2.data) {
                    this.qrCode64 = "data:image/jpeg;base64," + res2.data.encodedImage
                    this.chaveCopiaeCola = res2.data.payload
                    this.msgResultado = 'Pré-inscrição realizada com sucesso'
                    this.pagamentoPix = true
                    this.isLoading = false
                    this.consultaPagamentoPix(res.data.id)
                  }
                })
              }
            })
          } catch (error) {
            this.isLoading = false
            vm = this;
            vm.$refs.chamaSnackbar.snack("#F9A825","Falha ao realizar inscrição, tente novamente!","DESCULPE");
            this.close()
          }
        } else {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825","Falha ao realizar inscrição, tente novamente!","DESCULPE");
        }
      },

      consultaPagamentoPix(idPagamento) {
        try {
          this.verificaPagamento = setInterval(function() {
            axios.post(`${baseApiUrl}Pagamentos/AsaasCobrancaConsulta`, {"id": idPagamento}).then(res3 => {
              if (res3.data.status == 'RECEIVED') {
                this.inscricao.statusPagamento = "PAGO"
                this.inscricao.valorPago = this.valorEvento
                this.isLoading = true
                this.atualizaInscricao(this.finalizaInscricao)
                clearInterval(this.verificaPagamento)
              }
            })
          }.bind(this), 5000)
        } catch (error) {
          clearInterval(this.verificaPagamento)
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350","Não foi possível verificar o pagamento, tente novamente!","DESCULPE");
        }
      },

      closeDialog() {
        this.dialog = false
        this.pagamentoPix = false
        // evita refresh; apenas reseta validações
        this.$validator.reset()
      },

      compare(a, b) {
        // Use toUpperCase() to ignore character casing
        const dataA = a.fim;
        const dataB = b.fim;

        let comparison = 0;
        if (dataA > dataB) {
          comparison = 1;
        } else if (dataA < dataB) {
          comparison = -1;
        }
        return comparison;
      },

      scrollToCategoryId(id) {
          const element = document.getElementById(id);
          const elementPosition = element.offsetTop;
          const offsetPosition = elementPosition - 5;

          window.scrollTo({
              top: offsetPosition,
              behavior: "smooth"
          });
      },

      async pegaParametrosUrl() {
        this.isLoading = true
        var params = window.location.search.substring(1).split('&');
        if (params[0] != '') {
          var paramArray = {};                        // Criar objeto que vai conter os parametros
          for (var i = 0; i < params.length; i++) {   // Passar por todos os parametros
            var param = params[i].split('=');         // Dividir os parametros chave e valor
            paramArray[param[0]] = param[1];          // Adicionar ao objeto criado antes
          }
          if (paramArray['mac']) {
            this.enderecoMacUrl = paramArray['mac'].replaceAll('%3A',':')
          }
        }
        this.isLoading = false
      },

      async pegaTerminais(abrirDialogAoVarios = true, salvarSeUnico = true) {
        this.overlay = true
        await axios.get(baseApiUrl + 'Terminals?filter={"where":{"and":[{"empresaId":"62ab6e94853c213ed69cf2ff"},{"ativo":"true"}]}, "fields":{"enderecoMac": true, "nome": true, "id": true}}')
        .then(response => {
          if (response.data) {
            if (response.data.length == 1) {
              this.pedido.enderecoMac = response.data[0].enderecoMac
              if (salvarSeUnico) {
                this.salvarPedido(this.pedido.formaSelecionada)
              }
            } else {
              this.terminais = response.data
              if (abrirDialogAoVarios) this.dialogoPerguntaTerminal = true
            }
          }
        })
        this.overlay = false
      },
    }
  }
</script>

<style scoped>
  /* LOGIN */
  @import url('https://fonts.googleapis.com/css2?family=Oxygen:wght@300&display=swap');
  .limiter {
    width: 100%;
    margin: 0 auto;
  }

  .container-login {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 170px 15px 96px 15px; /* espaço top para as 2 app-bars e bottom para o footer */
    background: linear-gradient(180deg, #121212 0%, #1a1a1a 40%, #1e1e1e 100%);
    background-repeat: no-repeat;
    position: relative;
    z-index: 1;
    overflow-y: clip;
  }

   .container-resumo {
    width: 100%;
    min-height: 35vh;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    position: relative;
  }

  .texto {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  .login {
    min-width: 80%;
    border-radius: 15px;
    background-color: #fff;
    opacity: 0.9;
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .login-title {
    display: block;
    margin-left: auto;
    margin-right: auto;
    text-align: center
  }

  .footer {
  flex-shrink: 0;
  /* Prevent Chrome, Opera, and Safari from letting these items shrink to smaller than their content's default minimum size. */
  }

.v-dialog:not(.v-dialog--fullscreen){
    overflow-y: clip;
  }

  /* Dark base */
  .dark-page {
    background-color: #121212;
    color: #e0e0e0;
  }

  /* Category strip */
  .category-thumb {
    border-radius: 12px;
    overflow: hidden;
  }
  .category-thumb__overlay {
    padding-left: 6px;
    background: linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.45) 35%, rgba(0,0,0,0.7) 100%);
  }
  .category-thumb__label {
    margin: 0;
    padding: 6px 6px 8px 0;
    height: 28px;
    font-size: 13px;
    color: #fafafa;
    text-shadow: 0 1px 2px rgba(0,0,0,0.4);
  }

  /* Category header */
  .category-header {
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
    margin-top: 16px;
  }
  .category-header__title {
    color: #B0BEC5 !important;
    font-weight: 700;
    letter-spacing: .3px;
  }

  /* Product card */
  .product-card {
    border-color: #2a2a2a !important;
    margin-bottom: 10px;
    transition: transform .08s ease, box-shadow .2s ease;
  }
  .product-card:hover {
    transform: translateY(-1px);
  }
  .product-title {
    font-weight: 700;
    color: #ECEFF1 !important;
  }
  .product-subtitle {
    color: #B0BEC5 !important;
  }
  .product-price {
    padding-top: 2px;
    padding-bottom: 2px;
    color: #00BFA5;
    font-weight: 900;
  }
  .action-btn {
    text-transform: none;
  }

.card-disabled {
  pointer-events: none;
  opacity: 0.7;
}

</style>
